
      var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsCallPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  viewBox: "0 0 36 36"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icons-call-phone_74960f442ef817c2__a",
  x1: "76.393%",
  x2: "32.709%",
  y1: "91.07%",
  y2: "3.632%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--theme-primary, #810ea9)"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m34.326 25.493-4.898-4.772c-.754-.837-2.763-1.884-5.149-.419-.126.084-.21.126-.293.21l-1.967 1.967c-2.01-1.214-6.405-4.312-8.833-8.832l1.34-1.34c.293-.293 1.465-1.465 1.507-3.181.041-.838-.168-2.093-1.466-3.391L9.753.963a.721.721 0 0 0-.209-.168c-.963-.67-3.349-1.507-5.484.377C3.851 1.34-.795 5.358.628 12.098c.042.586.293 2.26 1.549 4.814 1.925 3.809 5.19 7.786 9.795 11.804.251.21 6.195 5.317 13.06 6.321.21.042.838.168 1.717.168 1.884 0 4.94-.503 7.367-3.265.419-.335 1.256-1.256 1.465-2.638.126-.837 0-2.135-1.172-3.6 0-.125-.042-.167-.083-.209zm-2.345 3.851c-.125.084-.167.126-.293.251-2.386 2.847-5.86 2.135-5.986 2.135-.042 0-.083 0-.125-.042-5.86-.879-11.344-5.525-11.386-5.567C4.437 17.58 3.977 11.888 3.977 11.763c0-.126 0-.21-.042-.335-1.088-4.772 2.135-7.66 2.302-7.786.544-.46 1.047-.377 1.298-.21l4.688 4.647c.335.335.46.628.46.88 0 .376-.334.753-.418.836l-.084.084-2.218 2.26c-.503.503-.628 1.214-.335 1.884C12.977 21.6 21.18 25.87 21.516 26.08c.628.335 1.424.21 1.926-.293l2.763-2.679c.335-.167.628-.21.795-.042l.084.084 4.814 4.688c.335.419.67 1.047.083 1.507z",
  fill: "url(#icons-call-phone_74960f442ef817c2__a)",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\">\r\n    <defs>\r\n        <linearGradient id=\"morfxeon0a\" x1=\"76.393%\" x2=\"32.709%\" y1=\"91.07%\" y2=\"3.632%\">\r\n            <stop offset=\"0%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n            <stop offset=\"100%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n        </linearGradient>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"url(#morfxeon0a)\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <path d=\"M34.326 25.493l-4.898-4.772c-.754-.837-2.763-1.884-5.149-.419-.126.084-.21.126-.293.21l-1.967 1.967c-2.01-1.214-6.405-4.312-8.833-8.832l1.34-1.34c.293-.293 1.465-1.465 1.507-3.181.041-.838-.168-2.093-1.466-3.391L9.753.963C9.67.879 9.628.837 9.544.795c-.963-.67-3.349-1.507-5.484.377C3.851 1.34-.795 5.358.628 12.098c.042.586.293 2.26 1.549 4.814 1.925 3.809 5.19 7.786 9.795 11.804.251.21 6.195 5.317 13.06 6.321.21.042.838.168 1.717.168 1.884 0 4.94-.503 7.367-3.265.419-.335 1.256-1.256 1.465-2.638.126-.837 0-2.135-1.172-3.6 0-.125-.042-.167-.083-.209zm-2.345 3.851c-.125.084-.167.126-.293.251-2.386 2.847-5.86 2.135-5.986 2.135-.042 0-.083 0-.125-.042-5.86-.879-11.344-5.525-11.386-5.567C4.437 17.58 3.977 11.888 3.977 11.763c0-.126 0-.21-.042-.335-1.088-4.772 2.135-7.66 2.302-7.786.544-.46 1.047-.377 1.298-.21l4.688 4.647c.335.335.46.628.46.88 0 .376-.334.753-.418.836l-.084.084-2.218 2.26c-.503.503-.628 1.214-.335 1.884C12.977 21.6 21.18 25.87 21.516 26.08c.628.335 1.424.21 1.926-.293l2.763-2.679c.335-.167.628-.21.795-.042l.084.084 4.814 4.688c.335.419.67 1.047.083 1.507z\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-call-phone.74960f442ef817c27d35cb833fa28461.svg"),
        {
          React: SvgIconsCallPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      